<p-dialog
  data-testid="product-selection-dialog"
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [style]="dialogStyle()"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [header]="dialogTitle()"
>
  <div class="flex flex-col h-full">
    <!-- Search Section -->
    <div class="flex-shrink-0 px-4 py-2">
      <div
        class="grid grid-cols-1 md:grid-cols-{{
          config.searchFields.length || 1
        }} gap-4"
      >
        <div *ngFor="let field of config.searchFields" class="space-y-2">
          <label class="block text-sm font-medium text-gray-700">
            {{ field.label | translate }}
          </label>
          <input
            [attr.data-testid]="'product-selection-search-input-' + field.key"
            pInputText
            [(ngModel)]="searchForm()[field.key]"
            [placeholder]="field.placeholder | translate"
            class="w-full"
          />
        </div>
      </div>
      <div class="flex gap-2 mt-3">
        <p-button
          data-testid="product-selection-search-btn"
          [label]="'common.actions.search' | translate"
          severity="info"
          size="small"
          (onClick)="onSearch()"
          styleClass="text-sm px-4 py-2"
        />
        <p-button
          data-testid="product-selection-reset-btn"
          [label]="'common.actions.reset' | translate"
          severity="secondary"
          outlined="true"
          size="small"
          (onClick)="onSearchReset()"
          styleClass="text-sm px-4 py-2"
        />
      </div>
    </div>

    <!-- Products Table -->
    <app-data-table
      data-testid="product-selection-table"
      [dataSource]="products"
      [columns]="config.tableColumns"
      [loading]="loading"
      [hasCheckColumn]="true"
      [rows]="pageSize()"
      [first]="(currentPage() - 1) * pageSize()"
      [totalRecords]="totalRecords"
      [selection]="selectedProducts()"
      [isRowDisabledFn]="isProductDisabled.bind(this)"
      [isRowSelectedFn]="getProductSelectionState.bind(this)"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
      [scrollHeight]="serviceConfig.scrollHeight"
    >
      <!-- Custom template for currency formatting -->
      <ng-template #customTemplate let-rowData let-column="column">
        @if (column?.template === "currencyTemplate") {
          <span class="text-xs text-gray-600 flex items-center justify-end">
            {{ formatCurrency(rowData) }}
          </span>
        } @else if (column?.template === "fulfillmentModeTemplate") {
          <span class="text-xs text-gray-600">
            {{ rowData ? (rowData | translate) : "-" }}
          </span>
        }
      </ng-template>
    </app-data-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      <p-button
        data-testid="product-selection-cancel-btn"
        [label]="'common.actions.cancel' | translate"
        severity="secondary"
        outlined="true"
        size="small"
        (onClick)="onCancel()"
        [disabled]="loading"
        styleClass="text-sm px-4 py-2"
      />
      <p-button
        data-testid="product-selection-confirm-btn"
        [label]="'common.actions.confirm' | translate"
        severity="info"
        size="small"
        (onClick)="onConfirm()"
        [disabled]="!hasSelection() || loading"
        [loading]="loading"
        styleClass="text-sm px-4 py-2"
      />
    </div>
  </ng-template>
</p-dialog>
